import { render } from "./StudentMaster.vue?vue&type=template&id=55830eb7&scoped=true"
import script from "./StudentMaster.vue?vue&type=script&lang=js"
export * from "./StudentMaster.vue?vue&type=script&lang=js"

import "./StudentMaster.vue?vue&type=style&index=0&id=55830eb7&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55830eb7"]])

export default __exports__